import { createContext, useContext, useRef, useCallback } from 'react';

const DataCacheContext = createContext(null);

const CACHE_TTL = 3 * 60 * 1000; // 3 minutes

export function DataCacheProvider({ children }) {
  const cache = useRef({});

  const get = useCallback((key) => {
    const entry = cache.current[key];
    if (!entry) return null;
    if (Date.now() - entry.ts > CACHE_TTL) {
      delete cache.current[key];
      return null;
    }
    return entry.data;
  }, []);

  const set = useCallback((key, data) => {
    cache.current[key] = { data, ts: Date.now() };
  }, []);

  const invalidate = useCallback((key) => {
    if (key) delete cache.current[key];
    else cache.current = {};
  }, []);

  return (
    <DataCacheContext.Provider value={{ get, set, invalidate }}>
      {children}
    </DataCacheContext.Provider>
  );
}

export const useDataCache = () => useContext(DataCacheContext);
